




























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import listsRepository from "@/services/listsRepository";
import notificationService from "@/services/notificationService";
import cCard from "@/components/default/Card.vue";
import DxList, { DxItemDragging } from "devextreme-vue/list";
import ToggleTitle from "@/components/default/ToggleTitle.vue";

@Component({
  components: {
    DxList,
    DxItemDragging,
    ToggleTitle,
    cCard,
  }
})
export default class CatalogList extends Vue {
  @Prop({ required: false })
  public listname?: string;

  @Prop({ required: false })
  public title?: string;

  public loading: boolean = false;
  public show: boolean = false;
  public showSaveButton: boolean = false;

  public deleteItem(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      try {
        await listsRepository.removeValue(self.listname as string, e.itemData);
        notificationService.saved();

        resolve(false);
      } catch (err) {
        notificationService.failedToSave();
        resolve(true);
      }
    });
  }

  public onDragStart(e: any) {
    this.showSaveButton = true;
  }

  public async addItem(e: any) {
    const item = prompt("Gelieve een waarde in te geven", "");

    if (item != null && item !== "") {
      if (this.listname != null && this.listname !== "") {
        // await listsRepository.addValue(this.listname, item as string);
        this.$store.dispatch("catalogs/addValue", {
          name: this.listname,
          value: item,
        });
      }
    }
  }

  public async saveList(e: any){
    this.$store.dispatch("catalogs/setList", {
      name: this.listname,
      value: this.list.values,
    });
    this.showSaveButton = false;
  }

  get list() {
    var i = this.$store.getters["catalogs/list"](this.listname);
    if (i == undefined) {
      this.postNewList(this.listname!);
    } else {
      return i;
    }
  }

  public async postNewList(name: string) {
    await listsRepository.addList(name).then((result) => {
      return result;
    });
  }
}
